import { Address, ClinicOptionType, Location } from '@/types';

const mapLocationToFormattedSelectOption = (location: Location) => {
  const address = location.address as Address;
  return {
    address: `${address?.address1}, ${address?.city}, ${address?.state}, ${address.country.code}`,
    id: location.code,
    clinic: `${address?.city === 'Watertown' ? 'Boston' : address.city}, ${address?.state}, ${address.country.code}`,
    value: location.code,
  };
};

const sortAlphabeticallyByClinic = (a: ClinicOptionType, b: ClinicOptionType) =>
  a.clinic.localeCompare(b.clinic);

export const getLocationOptions = (locations: Location[]) =>
  locations.map(mapLocationToFormattedSelectOption).sort(sortAlphabeticallyByClinic);

export const getLocationId = (optionId: string, data: Location[]) => {
  return data?.find((location: Location) => location.code === optionId);
};
